import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core'
import { Subscription } from 'rxjs'
import { NgIf } from '@angular/common'
import { MatIconModule } from '@angular/material/icon'
import { VolumeService } from '../../../services/volume.service'

@Component({
  selector: 'app-volume',
  standalone: true,
  imports: [NgIf, MatIconModule],
  templateUrl: './volume.component.html',
  styleUrls: ['./volume.component.scss'],
})
export class VolumeComponent implements OnInit, OnDestroy {
  volumeSubscription?: Subscription
  mutedSubscription?: Subscription
  useNativeVolumeDisplaySubscription?: Subscription

  enabled = true
  volume?: number
  muted?: boolean

  timer: any

  readonly className = 'active'
  readonly debounceDelayInMs = 2000
  readonly muteTimerDelayInMs = 2000

  @ViewChild('widget') widget?: ElementRef

  constructor(
    private cdr: ChangeDetectorRef,
    private renderer: Renderer2,
    private volumeService: VolumeService
  ) {
    // do nothing
  }

  ngOnInit(): void {
    this.volumeSubscription = this.volumeService.currentVolume$.subscribe(volume => {
      this.volume = volume
      this.debounceShowVolume()
    })
    this.mutedSubscription = this.volumeService.currentMuted$.subscribe(muted => {
      this.muted = muted
      this.debounceShowVolume()
    })
    this.useNativeVolumeDisplaySubscription = this.volumeService.useNativeVolumeDisplay$.subscribe(
      useNativeVolumeDisplay => {
        if (useNativeVolumeDisplay != null) {
          this.enabled = !useNativeVolumeDisplay
          this.cdr.markForCheck()
        }
      }
    )
  }

  ngOnDestroy(): void {
    this.volumeSubscription?.unsubscribe()
    this.mutedSubscription?.unsubscribe()
    this.useNativeVolumeDisplaySubscription?.unsubscribe()
  }

  debounceShowVolume(): void {
    if (this.timer) {
      clearTimeout(this.timer)
    }
    if (this.enabled) {
      this.show()
      this.timer = setTimeout(() => {
        this.hide()
        if (this.muted) {
          this.timer = setTimeout(() => {
            this.debounceShowVolume()
          }, this.muteTimerDelayInMs)
        }
      }, this.debounceDelayInMs)
    }
  }

  show(): void {
    if (this.widget) {
      this.renderer.addClass(this.widget.nativeElement, this.className)
    }
  }

  hide(): void {
    if (this.widget) {
      this.renderer.removeClass(this.widget.nativeElement, this.className)
    }
  }
}
